import OrderCargoOrderFinishedListResponse, {
  OrderCargoOrderFinishedListResponseDataItem,
  OrderCargoOrderFinishedListResponseItemPublicStatus,
} from "../../../../../api/raily/order/cargo-order/finished/list/order-cargo-order-finished-list.response";
import PublicStatus from "../../../../../types/public-status";
import OrderCargoOrderFinishedList, {
  OrderCargoOrderFinishedListItem,
} from "./order-cargo-order-finished-list";

const createPublicStatus = (
  responsePublicStatus: OrderCargoOrderFinishedListResponseItemPublicStatus,
): PublicStatus => {
  switch (responsePublicStatus) {
    case OrderCargoOrderFinishedListResponseItemPublicStatus.PRIVATE:
      return PublicStatus.PRIVATE;
    case OrderCargoOrderFinishedListResponseItemPublicStatus.PUBLIC:
      return PublicStatus.PUBLIC;
    case OrderCargoOrderFinishedListResponseItemPublicStatus.PUBLISHED:
      return PublicStatus.PUBLISHED;
  }
};

const createDataItem = (
  responseItem: OrderCargoOrderFinishedListResponseDataItem,
): OrderCargoOrderFinishedListItem => {
  return {
    uuid: responseItem.id,
    consumer: responseItem.consumer?.id
      ? {
          name: responseItem.consumer.name,
        }
      : null,
    dispatch: responseItem.dispatch,
    drivers: responseItem.drivers,
    externalOrderId: responseItem.externalId,
    internalOrderId: responseItem.humanId,
    isCancelled: responseItem.isCancelled,
    passengers: responseItem.passengers,
    producer: responseItem.producer.id
      ? {
          name: responseItem.producer.name,
        }
      : null,
    publicStatus: createPublicStatus(responseItem.publicStatus),
    routeAddresses: responseItem.rideAddresses,
    estimatedStartDate: responseItem.startTime,
    attentions: {
      newSharedPost: responseItem.attentions?.newSharedPost,
      newPlanEntryPost: responseItem.attentions?.newPlanEntryPost,
      cargoOrderEdit: responseItem.attentions?.cargoOrderEdit,
      cargoOrderCancel: responseItem.attentions?.cargoOrderCancel,
    },
    slkStatus: responseItem.slkStatus ?? null,
    fleetPartner: responseItem.fleetPartner,
  };
};

const createData = (
  responseData: OrderCargoOrderFinishedListResponseDataItem[],
): OrderCargoOrderFinishedListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: OrderCargoOrderFinishedListResponse,
): OrderCargoOrderFinishedList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const orderCargoOrderFinishedListFactory = {
  create,
};

export default orderCargoOrderFinishedListFactory;
